// extracted by mini-css-extract-plugin
export default {"menu":"_2-rUz1Tmbj1OsloMksvDd3","menuItem":"_26X9Hz53WjNBTdPwUiIaGf","iconMenu":"_3D4vsreZPFY2WzB571EZzG","hide":"_31Q9vukTdaYn9Jak-cwHl6","delete":"_2jHY8eg36vRhx4HW3inoOW"};